module.exports = __webpack_public_path__ + "static/media/shopify.420a7c69.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/shopify.svg
// module id = 1067
// module chunks = 1